import React from "react"
import { CardType } from "../../../lib/utils"
import InvestorCard from "./Card"
import ManageInvestor from "./ManageItem"

export default function InvestorDetails({ params }) {

  return <ManageInvestor
    params={ params }
    callback={ (data, setInvestor, removeInvestor) =>
      <InvestorCard
        investor={ data }
        setInvestor={ setInvestor }
        removeInvestor={ removeInvestor }
        cardType={ CardType.LARGE }
      />
    }
  />
}



// WEBPACK FOOTER //
// ./src/components/Financiers/Investors/Details.js